import backend from '@common/backend';

const BASE = '/chat-rules-acceptances';

export interface IReadChatRules {
	business_id: number;
	service_id: number;
}

export const readChatRules = async (data: IReadChatRules) => backend.post(`${BASE}`, data);
